import gql from 'graphql-tag';

const GET_HISTORIES = gql`
  query historyLogs(
    $where: HistoryLogWhereInput!
    $skip: Int
    $first: Int
    $orderBy: HistoryLogOrderByInput
  ) {
    historyLogs(where: $where, skip: $skip, first: $first, orderBy: $orderBy) {
      id
      author {
        id
        name
      }
      action
      type
      referenceId
      data
      createdAt
      updatedAt
    }
  }
`;

export default GET_HISTORIES;
